import { Box, BoxProps, Checkbox, FormControlLabel, Stack } from "@mui/material";

import { ROUTE_PATH } from "@/common/constants/routing";
import { useOnboardingContext } from "@/common/contexts/onboarding";
import { useAppHistory } from "@/common/hooks/routing/useAppHistory";
import { ApiEnumName } from "@/common/services/enum";
import { OnboardingStatus } from "@/core/api/generated/v1";

import AppCard from "../../../Card/AppCard";
import AppCardActionArea from "../../../Card/AppCardActionArea";
import AppCardContent from "../../../Card/AppCardContent";
import InlineApiEnumValue from "../../../Enum/InlineApiEnumValue";
import AppTooltip from "../../../Tooltip/AppTooltip";

interface Props {
  sx?: BoxProps["sx"];
}

export function OnboardingStepChecklist({ sx }: Props) {
  const history = useAppHistory();
  const onboardingContext = useOnboardingContext();

  return (
    <Stack gap={1} sx={sx}>
      {onboardingContext.enabledStepDefinitions?.map((stepDefinition, index) => {
        const stepPair = onboardingContext.getStepPairByDefinitionId(stepDefinition.id);
        const status = stepPair?.step?.status || OnboardingStatus.NotStarted;
        const isCompleted = status === OnboardingStatus.Completed;
        const isSkipped = status === OnboardingStatus.Skipped;
        const isCurrent = stepDefinition.id === onboardingContext.currentStepPair?.definition.id;

        return (
          <AppCard
            key={index}
            variant='outlined'
            sx={{
              backgroundColor: "transparent",
              borderColor: (th) => th.palette.dividerCustom.subtle,

              ...(isCompleted && {
                backgroundColor: (th) => th.palette.background.subtle,
              }),

              ...(isCurrent && {
                backgroundColor: (th) => th.palette.background.paper,
                boxShadow: (th) => th.shadows[3],
              }),
            }}
          >
            <AppCardActionArea
              enabled
              isDisableDefaultHoverStyles
              onClick={(e) => {
                const targetEl = e.target as HTMLElement;
                if (targetEl instanceof HTMLInputElement) {
                  return;
                }
                history.push(
                  ROUTE_PATH.ONBOARDING_VIEW_STEP({
                    stepDefinitionId: stepDefinition.id,
                  }),
                );
              }}
            >
              <AppCardContent
                sx={{
                  py: 1,
                  px: 3,
                }}
              >
                <FormControlLabel
                  sx={
                    {
                      // ...((isCompleted || isSkipped) && {
                      //   color: "text.secondary",
                      //   textDecoration: "line-through",
                      // }),
                      // ...(isSkipped && {
                      //   color: "text.secondary",
                      //   // textDecoration: "line-through",
                      // }),
                    }
                  }
                  label={
                    <AppTooltip
                      title={
                        <InlineApiEnumValue type={ApiEnumName.OnboardingStatus} value={status} />
                      }
                      enterDelayPreset='large'
                    >
                      <Box>{stepDefinition.title}</Box>
                    </AppTooltip>
                  }
                  control={
                    <AppTooltip
                      title={isCompleted || isSkipped ? "Mark as in progress" : "Mark as complete"}
                      enterDelayPreset='large'
                    >
                      <Checkbox
                        // sx={{ color: "red" }}
                        checked={isCompleted}
                        indeterminate={isSkipped}
                        color={isSkipped ? "default" : "secondary"}
                        onChange={(e) => {
                          e.stopPropagation();
                          if (isCompleted || isSkipped) {
                            onboardingContext.startStep(stepDefinition.id || "");
                          } else {
                            onboardingContext.completeStep(stepDefinition.id || "");
                          }
                        }}
                      />
                    </AppTooltip>
                  }
                />
              </AppCardContent>
            </AppCardActionArea>
          </AppCard>
        );
      })}
    </Stack>
  );
}
